if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        document.body.classList.add('sticky-atc-bar-enabled');

        this.container = this.closest('.sticky-atc-bar');
        this.productId = this.getAttribute('data-product-id');
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);

        if (!this.container) return;

        this.bindAddToCart();

        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.container.classList.toggle('sticky-atc-bar--show', entry.intersectionRatio !== 1);
            });
          },
          { threshold: 1, rootMargin: '-80px 0px 0px 0px' }
        );

        observer.observe(this.productFormActions);
      }

      bindAddToCart() {
        const form = this.querySelector('.sticky-atc-bar__form');
        const button = this.querySelector('[name="add"]');

        if (!form || !button) return;

        button.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const variantInput = form.querySelector('[name="id"]');
            const quantityInput = form.querySelector('[name="quantity"]');

            if (!variantInput || !variantInput.value) return;

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: Number(variantInput.value),
                quantity: quantityInput ? Number(quantityInput.value || 1) : 1
              })
            })
              .then((response) => response.json())
              .then(() => {
                window.location.href = '/cart';
              })
              .catch((error) => {
                console.error('Sticky add to cart error:', error);
              });
          },
          true
        );
      }
    }
  );
}



